if (!customElements.get('hero-background-video')) {
  customElements.define('hero-background-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const video = this.video;
      let pending = false;
      video.defaultMuted = true;
      video.muted = true;
      video.autoplay = true;
      video.playsInline = true;
      const play = () => {
        if (!this.isConnected || document.hidden || pending || !video.paused) return;
        video.muted = true;
        pending = true;
        video.play().catch(() => {}).finally(() => { pending = false; });
      };
      video.addEventListener('playing', () => {
        video.hidden = false;
      }, options);
      video.addEventListener('error', () => {
        video.hidden = true;
      }, options);
      video.addEventListener('loadeddata', play, options);
      video.addEventListener('canplay', play, options);
      document.addEventListener('visibilitychange', play, options);
      window.addEventListener('pageshow', play, options);
      document.addEventListener('pointerdown', play, options);
      document.addEventListener('keydown', play, options);
      play();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.video?.pause();
    }
  });
}
